import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from 'dm-src/app/modules/dashboard/dashboard.component';
import { AuthGuard } from 'shared';
import { OrdersComponent } from 'dm-src/app/modules/orders/orders.component';
import { AccountsComponent } from 'dm-src/app/modules/accounts/accounts.component';
import { ConfirmRegistrationComponent } from 'dm-src/app/modules/confirm-registration/confirm-registration.component';
import { LoginComponent } from 'dm-src/app/modules/login/login.component';
import { LogoutComponent } from 'dm-src/app/modules/login/logout.component';
import { RegistrationComponent } from 'dm-src/app/modules/registration/registration.component';
import { TasksComponent } from 'dm-src/app/modules/tasks/tasks.component';
import { MyTasksComponent } from 'dm-src/app/modules/my-tasks/my-tasks.component';
import { TaskEditComponent } from 'dm-src/app/modules/tasks/task.edit.component';
import { CollectingComponent } from 'dm-src/app/modules/collecting/collecting.component';
import { ProviderOrdersComponent } from 'dm-src/app/modules/provider-orders/provider-orders.component';
import { AdminGuard } from 'shared';
import { ProviderAdminGuard } from 'shared';
import { TaskGeneratorComponent } from 'dm-src/app/modules/task-generator/task-generator.component';
import { RoleGuard } from 'shared';
import { UserRole } from 'shared';
import { MyWorktimesComponent } from 'dm-src/app/modules/my-worktimes/my-worktimes.component';
import { MyAccountComponent } from 'dm-src/app/modules/my-account/my-account.component';
import { SupplierResourcesComponent } from 'dm-src/app/modules/supplier-resources/supplier-resources.component'; // CLI imports router
import { TourPlannerComponent } from 'dm-src/app/modules/tour-planner/tour-planner.component'; // CLI imports router
import { SupplierRegionsComponent } from './modules/supplier-regions/supplier-regions.component';
import { InstantDeliveryComponent } from 'dm-src/app/modules/instant-delivery/instant-delivery.component';
import { ForgotPasswordComponent } from './modules/login/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './modules/login/change-password/change-password.component';
import { SupplierTrackingComponent } from './modules/supplier-tracking/supplier-tracking.component';
import { SupplierControlComponent } from './modules/supplier-control/supplier-control.component';
import { DailyReviewComponent } from './modules/daily-review/daily-review.component';
import { DepositComponent } from './modules/deposit/deposit.component';
import { PermissionRequestWindowComponent } from 'dm-src/app/modules/permission-request-window/permission-request-window.component';
import { KnowledgeBaseComponent } from './modules/knowledge-base/knowledge-base.component';
import { DailyFeedbackComponent } from './modules/daily-feedback/daily-feedback.component';
import { DefectiveProductsComponent } from './modules/defective-products/defective-products.component';
import { ReturnDepositComponent } from './modules/return-deposit/return-deposit.component';
import { CustomPage1Component } from './modules/custom-pages/custom-page-1/custom-page-1.component';
import { CustomPage2Component } from './modules/custom-pages/custom-page-2/custom-page-2.component';
import { CustomPage3Component } from './modules/custom-pages/custom-page-3/custom-page-3.component';    
import { CustomPage4Component } from './modules/custom-pages/custom-page-4/custom-page-4.component';
import { CustomPage5Component } from './modules/custom-pages/custom-page-5/custom-page-5.component';


const routes: Routes = [
    { path: '', component: DashboardComponent, pathMatch: 'full' },
    { path: 'login/:usr/:pw', component: LoginComponent, pathMatch: 'full' },
    { path: 'login', component: LoginComponent, pathMatch: 'full' },
    {
        path: 'logout',
        canActivate: [AuthGuard],
        component: LogoutComponent,
        pathMatch: 'full',
    },
    {
        path: 'login/forgotpassword',
        component: ForgotPasswordComponent,
        pathMatch: 'full',
    },
    { path: 'login/changepassword', component: ChangePasswordComponent },
    {
        path: 'orders',
        canActivate: [AdminGuard],
        component: OrdersComponent,
        pathMatch: 'full',
    },
    {
        path: 'provider/orders',
        canActivate: [ProviderAdminGuard],
        component: ProviderOrdersComponent,
        pathMatch: 'full',
    },
    {
        path: 'accounts',
        canActivate: [AdminGuard],
        component: AccountsComponent,
        pathMatch: 'full',
    },
    {
        path: 'accounts/confirm-registration',
        component: ConfirmRegistrationComponent,
        pathMatch: 'full',
    },
    { path: 'registration', component: RegistrationComponent, pathMatch: 'full' },
    {
        path: 'tasks',
        canActivate: [AdminGuard],
        component: TasksComponent,
        pathMatch: 'full',
    },
    {
        path: 'tour-planner',
        canActivate: [AdminGuard],
        component: TourPlannerComponent,
        pathMatch: 'full',
    },
    {
        path: 'task-generator',
        canActivate: [RoleGuard],
        component: TaskGeneratorComponent,
        data: { roles: [UserRole.Picker, UserRole.Deliverer] },
        pathMatch: 'full',
    },
    {
        path: 'my-tasks',
        canActivate: [RoleGuard],
        component: MyTasksComponent,
        data: {
            roles: [UserRole.Administrator, UserRole.Picker, UserRole.Deliverer],
        },
        pathMatch: 'full',
    },
    {
        path: 'instant-delivery',
        canActivate: [RoleGuard],
        component: InstantDeliveryComponent,
        data: {
            roles: [UserRole.Administrator, UserRole.InstantDeliverer],
        },
        pathMatch: 'full',
    },
    {
        path: 'my-worktimes',
        canActivate: [RoleGuard],
        component: MyWorktimesComponent,
        data: {
            roles: [UserRole.Administrator, UserRole.Picker, UserRole.Deliverer],
        },
        pathMatch: 'full',
    },
    {
        path: 'my-account',
        canActivate: [AuthGuard],
        component: MyAccountComponent,
        pathMatch: 'full',
    },
    {
        path: 'supplier-resources',
        canActivate: [AdminGuard],
        component: SupplierResourcesComponent,
        pathMatch: 'full',
    },
    {
        path: 'supplier-regions',
        canActivate: [RoleGuard],
        component: SupplierRegionsComponent,
        data: {
            roles: [UserRole.Administrator, UserRole.Supporter],
        },
        pathMatch: 'full',
    },
    {
        path:'custom-page-1',
        canActivate: [RoleGuard],
        component: CustomPage1Component,
        data: {
            roles: [UserRole.Administrator, UserRole.Picker, UserRole.Deliverer],
        },
        pathMatch: 'full',
    },
    {
        path:'custom-page-2',
        canActivate: [RoleGuard],
        component: CustomPage2Component,
        data: {
            roles: [UserRole.Administrator, UserRole.Picker, UserRole.Deliverer],
        },
        pathMatch: 'full',
    },
    {
        path:'custom-page-3',
        canActivate: [RoleGuard],
        component: CustomPage3Component,
        data: {
            roles: [UserRole.Administrator, UserRole.Picker, UserRole.Deliverer],
        },
        pathMatch: 'full',
    },
        {
        path:'custom-page-4',
        canActivate: [RoleGuard],
        component: CustomPage4Component,
        data: {
            roles: [UserRole.Administrator, UserRole.Picker, UserRole.Deliverer],
        },
        pathMatch: 'full',
    },
        {
        path:'custom-page-5',
        canActivate: [RoleGuard],
        component: CustomPage5Component,
        data: {
            roles: [UserRole.Administrator, UserRole.Picker, UserRole.Deliverer],
        },
        pathMatch: 'full',
    },
    {
        path: 'tasks/new',
        canActivate: [AdminGuard],
        component: TaskEditComponent,
        pathMatch: 'full',
    },
    {
        path: 'tasks/edit/:{taskId}',
        canActivate: [AdminGuard],
        component: TaskEditComponent,
        pathMatch: 'full',
    },
    {
        path: 'collecting/:{taskId}/:{orderId}',
        canActivate: [AuthGuard],
        component: CollectingComponent,
        pathMatch: 'full',
    },
    {
        path: 'multi-collecting',
        canActivate: [AuthGuard],
        component: CollectingComponent,
        pathMatch: 'full',
    },
    {
        path: 'tracking',
        canActivate: [RoleGuard],
        component: SupplierTrackingComponent,
        data: {
            roles: [UserRole.Administrator],
        },
        pathMatch: 'full',
    },
    {
        path: 'supplier-control',
        canActivate: [RoleGuard],
        component: SupplierControlComponent,
        data: {
            roles: [UserRole.SupplierSupervisor],
        },
        pathMatch: 'full',
    },
    {
        path: 'daily-review',
        canActivate: [RoleGuard],
        component: DailyReviewComponent,
        data: {
            roles: [UserRole.Picker, UserRole.Deliverer],
        },
        pathMatch: 'full',
    },
    {
        path: 'deposit',
        canActivate: [RoleGuard],
        component: DepositComponent,
        data: {
            roles: [UserRole.Picker, UserRole.Deliverer],
        },
        pathMatch: 'full',
    },
    {
        path: 'knowledge-base',
        canActivate: [RoleGuard],
        data: {
            roles: [UserRole.Picker, UserRole.Deliverer],
        },
        component: KnowledgeBaseComponent,
        pathMatch: 'full',
    },
    {
        path: 'daily-feedback',
        canActivate: [RoleGuard],
        data: {
            roles: [UserRole.Picker, UserRole.Deliverer],
        },
        component: DailyFeedbackComponent,
        pathMatch: 'full',
    },
    {
        path: 'defective-products',
        canActivate: [RoleGuard],
        data: {
            roles: [UserRole.Picker, UserRole.Deliverer],
        },
        component: DefectiveProductsComponent,
        pathMatch: 'full',
    },
    {
        path: 'return-deposit',
        canActivate: [RoleGuard],
        data: {
            roles: [UserRole.User],
        },
        component: ReturnDepositComponent,
        pathMatch: 'full',
    },
    {
        path: 'app-permission',
        component: PermissionRequestWindowComponent,
        pathMatch: 'full',
    },
]; // sets up routes constant where you define your routes

// configures NgModule imports and exports
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
